import Vue from 'vue'
import UUID from 'uuid/v4'
import * as types from './mutation-types'

const mutations = {
  /**
   * Add order to sync. queue
   * @param {Object} product data format for products is described in /doc/ElasticSearch data formats.md
   */
  [types.ORDER_PLACE_ORDER] (state, order) {
    const ordersCollection = Vue.prototype.$db.ordersCollection
    const orderId = order.order_id || UUID() // timestamp as a order id is not the best we can do but it's enough
    order.order_id = orderId.toString()
    order.created_at = new Date()
    order.updated_at = new Date()

    ordersCollection.setItem(orderId.toString(), order, (err, resp) => {
      if (err) console.error(err)
      if (!order.transmited) {
        Vue.prototype.$bus.$emit('order/PROCESS_QUEUE') // process checkout queue
      }
      console.info('Order placed, orderId = ' + orderId)
    }).catch((reason) => {
      console.error(reason) // it doesn't work on SSR
    }) // populate cache
  },
  [types.ORDER_LAST_ORDER_WITH_CONFIRMATION] (state, payload) {
    state.last_order_confirmation = payload
  },
  [types.ORDER_SET_LAST_DATA] (state, payload) {
    state.lastOrderData = payload
  }
}

export default mutations
